/* src/app/ui/toolbar/toolbar.component.scss */
.btn-tools {
  width: 3.5rem;
  height: 3.5rem;
  padding: 0;
  border-radius: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  border: 0;
  margin-bottom: 0.75rem;
}
.btn-tools:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
}
/*# sourceMappingURL=toolbar.component.css.map */
